// src/components/layout/BackButton.js
// "Zpět" link. With `to` it always goes to that page (safe for deep links opened from
// an e-mail); without it, it goes back in history and falls back to `fallback` when the
// page was opened directly (audit FL-20).
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CLASSES =
  'inline-flex items-center gap-2 rounded-md px-2 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500';

const BackButton = ({ to, label = 'Zpět', fallback = '/' }) => {
  const navigate = useNavigate();

  if (to) {
    return (
      <Link to={to} className={CLASSES}>
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        {label}
      </Link>
    );
  }

  const goBack = () => {
    const idx = window.history.state && window.history.state.idx;
    if (typeof idx === 'number' && idx > 0) navigate(-1);
    else navigate(fallback);
  };

  return (
    <button type="button" onClick={goBack} className={CLASSES}>
      <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      {label}
    </button>
  );
};

export default BackButton;
